import { useMemo } from "react";
import ServiceModel from "../../../data/entities/booking/ServiceModel";

export const useServicesByType = (locationServices: ServiceModel[] | null) => {
  return useMemo(() => {
    if (!locationServices) return {};
    return locationServices.reduce((groups: { [key: string]: ServiceModel[] }, service: ServiceModel) => {
      if (!service.serviceType) return groups;
      const type = service.serviceType.name;
      if (!groups[type]) {
        groups[type] = [];
      }
      groups[type].push(service);
      return groups;
    }, {});
  }, [locationServices]);
};
